<template>
  <div class="container">
    <p>
      学科知识库通过资源整合和发现功能节省文献调研时间，精准的获取自己所需要的信息。可根据选择关注学科，提供最前沿的相关技术概念分析、期刊、资讯、学者、话题、学科前沿资讯，等多个最新信息去帮助读者用户科研选题，确定研究方向。
    </p>
    <img src="../../assets/images/newhelp/help34.png" alt="" />
    <img src="../../assets/images/newhelp/help35.png" alt="" />
  </div>
</template>
<script>
export default {
  name: "Page1",
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.container {
  padding: 75px;
  p,
  img {
    margin-bottom: 15px;
    font-size: 18px;
    max-width: 100%;
  }
  .red {
    color: #fa0000;
  }
}
</style>
